import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Mail, Phone, Clock } from 'lucide-react';
import { Logo } from './Logo';
export const Footer = () => {
  return <footer className="bg-slate-900 text-white" data-id="element-64">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-65">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8" data-id="element-66">
          <div data-id="element-67">
            <div className="flex items-center mb-4" data-id="element-68">
              <Logo size="md" data-id="element-69" />
            </div>
            <p className="text-slate-400 text-sm" data-id="element-70">
              Professional appliance repair and maintenance services across the
              UK.
            </p>
          </div>
          <div data-id="element-71">
            <h3 className="text-lg font-semibold mb-4" data-id="element-72">Quick Links</h3>
            <nav className="flex flex-col space-y-2" data-id="element-73">
              <Link to="/about" className="text-slate-400 hover:text-blue-400 transition-colors text-sm" data-id="element-74">
                About Us
              </Link>
              <Link to="/repair-services" className="text-slate-400 hover:text-blue-400 transition-colors text-sm" data-id="element-75">
                Repair Services
              </Link>
              <Link to="/faq" className="text-slate-400 hover:text-blue-400 transition-colors text-sm" data-id="element-76">
                FAQs
              </Link>
              <Link to="/contact" className="text-slate-400 hover:text-blue-400 transition-colors text-sm" data-id="element-77">
                Contact Us
              </Link>
            </nav>
          </div>
          <div data-id="element-78">
            <h3 className="text-lg font-semibold mb-4" data-id="element-79">Legal</h3>
            <nav className="flex flex-col space-y-2" data-id="element-80">
              <Link to="/terms-of-service" className="text-slate-400 hover:text-blue-400 transition-colors text-sm" data-id="element-81">
                Terms & Conditions
              </Link>
              <Link to="/cancellation" className="text-slate-400 hover:text-blue-400 transition-colors text-sm" data-id="element-82">
                Cancellation Policy
              </Link>
              <Link to="/refund" className="text-slate-400 hover:text-blue-400 transition-colors text-sm" data-id="element-83">
                Refund Policy
              </Link>
              <Link to="/privacy-policy" className="text-slate-400 hover:text-blue-400 transition-colors text-sm" data-id="element-84">
                Privacy & Cookie Policy
              </Link>
            </nav>
          </div>
          <div data-id="element-85">
            <h3 className="text-lg font-semibold mb-4" data-id="element-86">Contact Info</h3>
            <div className="flex flex-col space-y-3 text-sm" data-id="element-87">
              <div className="flex items-start space-x-2 text-slate-400" data-id="element-88">
                <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5" data-id="element-89" />
                <span data-id="element-90">112-116 The Broadway, London, NW7 3TB</span>
              </div>
              <div className="flex items-center space-x-2 text-slate-400" data-id="element-91">
                <Phone className="w-5 h-5 flex-shrink-0" data-id="element-92" />
                <a href="tel:08000554969" className="hover:text-blue-400 transition-colors" data-id="element-93">
                  0800 055 4969
                </a>
              </div>
              <div className="flex items-center space-x-2 text-slate-400" data-id="element-94">
                <Mail className="w-5 h-5 flex-shrink-0" data-id="element-95" />
                <a href="mailto:Benjobalolong082@gmail.com" className="hover:text-blue-400 transition-colors break-all" data-id="element-96">
                  Benjobalolong082@gmail.com
                </a>
              </div>
              <div className="flex items-start space-x-2 text-slate-400" data-id="element-97">
                <Clock className="w-5 h-5 flex-shrink-0 mt-0.5" data-id="element-98" />
                <div data-id="element-99">
                  <p data-id="element-100">Mon-Fri: 9:00am–5:00pm</p>
                  <p data-id="element-101">Sat-Sun: Closed</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-slate-800 pt-8" data-id="element-102">
          <div className="flex flex-wrap justify-center gap-6 mb-6" data-id="element-103">
            <div className="flex items-center space-x-2 text-slate-400 text-sm" data-id="element-104">
              <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center" data-id="element-105">
                ✓
              </div>
              <span data-id="element-106">UK-Based</span>
            </div>
            <div className="flex items-center space-x-2 text-slate-400 text-sm" data-id="element-107">
              <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center" data-id="element-108">
                ✓
              </div>
              <span data-id="element-109">Vetted Engineers</span>
            </div>
            <div className="flex items-center space-x-2 text-slate-400 text-sm" data-id="element-110">
              <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center" data-id="element-111">
                ✓
              </div>
              <span data-id="element-112">Clear Pricing</span>
            </div>
            <div className="flex items-center space-x-2 text-slate-400 text-sm" data-id="element-113">
              <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center" data-id="element-114">
                ✓
              </div>
              <span data-id="element-115">Secure Payments</span>
            </div>
          </div>
          <p className="text-center text-slate-500 text-sm" data-id="element-116">
            © {new Date().getFullYear()} Taskpoint. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
};